import React, { useMemo, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { VO_BIRTHDAY_GIFTS } from "./voBirthday";

export default function VoBirthdayDialog({
  open,
  person,
  busy = false,
  error = "",
  onClose,
  onSend,
}) {
  const [gift, setGift] = useState("cake");
  const [message, setMessage] = useState("");
  const name = useMemo(
    () => String(person?.userName || "colega").trim().split(/\s+/)[0] || "colega",
    [person]
  );

  if (!open || !person) return null;
  return (
    <Dialog open onClose={busy ? undefined : onClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ fontWeight: 800 }}>Parabéns para {name}</DialogTitle>
      <DialogContent>
        <Typography sx={{ color: "text.secondary", fontSize: "0.88rem", mb: 1.5 }}>
          Escolha um presente virtual e, se quiser, escreva um recado. {name} vê no piso.
        </Typography>
        <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap sx={{ mb: 1.5 }}>
          {VO_BIRTHDAY_GIFTS.map((item) => {
            const selected = gift === item.id;
            return (
              <Button
                key={item.id}
                onClick={() => setGift(item.id)}
                sx={{
                  textTransform: "none",
                  fontWeight: 800,
                  borderRadius: 999,
                  minWidth: 0,
                  px: 1.25,
                  bgcolor: selected ? "#f3c4d8" : "rgba(0,0,0,0.04)",
                  color: selected ? "#3a2414" : "text.primary",
                }}
              >
                {item.emoji} {item.label}
              </Button>
            );
          })}
        </Stack>
        <TextField
          fullWidth
          multiline
          minRows={2}
          label="Recado (opcional)"
          value={message}
          onChange={(e) => setMessage(e.target.value.slice(0, 180))}
          helperText={`${message.length}/180`}
        />
        {error ? (
          <Box sx={{ mt: 1.25, color: "error.main", fontSize: "0.82rem", fontWeight: 600 }}>
            {error}
          </Box>
        ) : null}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={busy} sx={{ textTransform: "none" }}>
          Agora não
        </Button>
        <Button
          variant="contained"
          disabled={busy}
          onClick={() => onSend?.({ gift, message })}
          sx={{ textTransform: "none", fontWeight: 800 }}
        >
          {busy ? "Enviando…" : "Enviar parabéns"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
